import React from "react";

import Avatar from "~/ui/legacy/Avatar";

import styles from "./TalkingHeads.module.css";

export default function TalkingHeads({ teammates }: { teammates: FellowUser[] }) {
	const users = teammates
		.filter(user => !!user.name)
		.map(user => ({
			id: user.id.toString(),
			fullName: user.name,
			firstName: user.name.split(" ")[0],
			image: user.image,
		}));

	return (
		<div className={styles.teammates}>
			<h5>Your teammates are already using Fellow</h5>
			<div className={styles.avatarList}>
				{users.map(user => (
					<Avatar key={user.id} tooltip link={false} width="3.5em" user={user} />
				))}
			</div>
		</div>
	);
}
